var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 65,
    viewBox: "0 0 42 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 65,
    fill: "url(#pattern0_263_1184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_263_1184",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_263_1184",
    transform: "matrix(0.0111111 0 0 0.00717949 0 0.176923)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_263_1184",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADk0lEQVR4nO2cS2vUUBSAU6tUa1sXWmmr4MKVWzdq7cZFN4KIP0EFFaSKWK0/wUqr4GMvxR9gEUG7FKEqiNNKXdWNuhDtQukDx6qfXHpBKclMkpncV84HgSGTx7kfmXuTc08migRBEARBEARBEIRsAJuBi8BLYIlk1HcvgAtAW8bTlBtgNzBDdipqX9vx+3Qlz+SQ/L9subLrobuLRhmqe6Kyw1qf3CjTttvhPMBiE0QvRgGP/mVjqWl3Ow2M/mWjkvtupwmjf9mo5LqymzT6l40hW6N/2Zi2NfqXjcU8ooUciGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDiGhDhCC6ClwF+vQyotc5RQiiR2JiVLKdIgTRvTEx9uAYIYjui4lxF44RatdxDccIQXRV98nBDYZlrL37AzwBTgH7gA69qM+n9XdqmyQW8oguWzXpLDCQwsuA3jaOZ3lEq1cGQuYzMA+sAFNAZwY3nXqfFX2Mj8Bv4GQe0W26ij0kHgIngC2ZhdT31QVsauQdlhBkvweORC6jr+whVc3u6QD5Nu5hR3AAoB24B3zSi/rcbjuuoABagccxvwy1rtV2fN4BbAP2rJcHjNXohsbXbbsR2KuOZbwBrgO0ADeAZS3vGzCpX/cbTtHnq1TtJeAR8F2vW9HHbMkT0PkQ/46BYlOrw3kCUnwBbgPH9c+s6fefptF3IUUxmycgH3mtUqd12rVQ4Plz5Tp8Yx7YkaJ/Xi0whtXM/TR+8QvYnzJHUTQdIYu+n6I9/cCEgVgeAIdDFd2f0IYNwFlgzkJM74BzKoZQRC+rB4eENtyyHRxwMxTRrxLi7yt44EuLiqEnBNHPa/TJrnAgBNFvEuLvBn7YDk7HsL2WaF9yz1X1/08JbRi1HZyKIVGyh5OzR2vkldWDjC3m6+axPZucnarRjsE6JQJFoc45WFOyh5OzT70V7dnk7DFvuw6PJmd/JuUXvBgMfQfY6dDtXXcUKsAh3OFgFCpArxeP4CEAjNu2rGbVo9BhLU16xlKadE6fO/vMuM9gLvE/kZQfLw2sFZUXzVbb7XSCoidnbbfPGQouN/hqu31lKaCZsd0+ZwCuFCj6su32OYMuohltoMhxWG87qfdFH+t66W7lMrxzkrVsdyymllodoyvVSYV/SCF6ZA6dx76rX2v7ANxptJL2L8Bg5fEKAkTeAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJob);
export default __webpack_public_path__ + "static/media/NewJob.1e4beddad48797ed0f77a447da67881a.svg";
export { ForwardRef as ReactComponent };